import register from '../../util/init';
import {updateLinkState} from '../../util/link_state';
import {flickity, flickityTriggers} from '../../util/flickity';

function storiesDetail (container) {
  // update links
  updateLinkState(document.querySelectorAll('nav.stories'));

  // TYPE: PROJECT
  if (container.classList.contains('stories-project')) {
    // gallery init
    container.querySelectorAll('.gallery').forEach((el) => {
      if (el.childElementCount > 1) {
        const flkty = flickity(el, {
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          prevNextButtons: false
        });
        // TODO setup triggers

        //   flickityTriggers(flkty, container.querySelector('.custom nav'));
        //   container.querySelectorAll('.custom nav .year h2 a').forEach((yearTrigger) => {
        //     yearTrigger.addEventListener('click', (e) => {
        //       e.preventDefault();
        //       container.querySelector('.custom nav .year.is-selected').classList.remove('is-selected');
        //       findClosest(yearTrigger, '.year').classList.add('is-selected');
        //     });
        //   });

      }
    });
  }

  // const handler = {
  //   resize: function (w, h) {
  //
  //   }, scroll: function (t, l, d) {
  //   }
  // };
  // return handler;
}
register('stories-detail', storiesDetail);



// WEBPACK FOOTER //
// ./assets/j/src/stories/detail.js